import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BumdesNav = ({ authUser, signOut }) => {
  const location = useLocation();

  const isBumdesProgram = !!authUser?.activeSession?.isProgram;
  const isClassified = !!authUser?.activeSession?.isClassified;
  const isPreSurveyDone = !!authUser?.activeSession?.isPreSurveyDone;

  const isPreSurveyDisabled = false; // Always accessible
  const isVeciDisabled = !isPreSurveyDone; // Locked until Pre-Survey is done

  return (
    <div className='dropdown'>
      <a
        href='#/'
        className='d-inline-flex align-items-center link-dark text-decoration-none dropdown-toggle px-3 py-2 rounded-pill bg-white border shadow-xs transition-all hover-scale'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        style={{ border: '1px solid #e2e8f0' }}
      >
        <div
          className='p-1 bg-info bg-opacity-10 text-info rounded-circle me-2 d-flex align-items-center justify-content-center'
          style={{ width: '32px', height: '32px' }}
        >
          <i className='bi bi-shop small'></i>
        </div>
        <div className='text-start me-2'>
          <div
            className='fw-bold text-dark mb-0 leading-tight'
            style={{ fontSize: '0.875rem' }}
          >
            {authUser?.fullName}
          </div>
          <div
            className='text-muted small'
            style={{ fontSize: '0.75rem' }}
          >
            Mitra BUMDes
          </div>
        </div>
      </a>

      <ul
        className='dropdown-menu dropdown-menu-lg-end shadow-lg border-0 rounded-4 p-2 mt-2 mt-lg-3'
        style={{
          minWidth: '260px',
          border: '1px solid rgba(0,0,0,0.05)',
        }}
      >
        <li className='px-3 py-2 mb-2'>
          <h6 className='fw-bold text-dark mb-0'>{authUser?.fullName}</h6>
          <small className='text-muted'>{authUser?.email}</small>
          <div className='mt-2'>
            <span className='badge bg-info bg-opacity-10 text-info rounded-pill x-small'>
              Mitra BUMDes
            </span>
          </div>
        </li>

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/bumdes/home' ? 'active' : ''}`}
            to='/bumdes/home'
          >
            <i
              className={`bi bi-house-fill ${location.pathname === '/bumdes/home' ? 'text-white' : 'text-info opacity-75'}`}
            ></i>
            <span>Dashboard</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${isPreSurveyDisabled ? 'text-muted opacity-50 pe-none' : location.pathname === '/bumdes/pre-survey' ? 'active' : ''}`}
            to={!isPreSurveyDisabled ? '/bumdes/pre-survey' : '#'}
            onClick={(e) => {
              if (isPreSurveyDisabled) e.preventDefault();
            }}
          >
            <i
              className={`bi bi-patch-question-fill ${location.pathname === '/bumdes/pre-survey' ? 'text-white' : 'text-info opacity-75'}`}
            ></i>
            <span>Pre-Survey</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${isVeciDisabled ? 'text-muted opacity-50 pe-none' : location.pathname === '/bumdes/veci' ? 'active' : ''}`}
            to={!isVeciDisabled ? '/bumdes/veci' : '#'}
            onClick={(e) => {
              if (isVeciDisabled) e.preventDefault();
            }}
          >
            <i
              className={`bi bi-clipboard-data-fill ${location.pathname === '/bumdes/veci' ? 'text-white' : 'text-info opacity-75'}`}
            ></i>
            <span>Survey VECI T0</span>
          </Link>
        </li>

        {isBumdesProgram && isClassified && (
          <li>
            <Link
              className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/bumdes/bmc' ? 'active' : ''}`}
              to='/bumdes/bmc'
            >
              <i
                className={`bi bi-grid-3x3-gap-fill ${location.pathname === '/bumdes/bmc' ? 'text-white' : 'text-info opacity-75'}`}
              ></i>
              <span>BMC</span>
            </Link>
          </li>
        )}

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <a
            onClick={(e) => {
              e.preventDefault();
              signOut();
            }}
            className='dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 text-danger'
            href='#/'
          >
            <i className='bi bi-box-arrow-right'></i>
            <span className='fw-bold'>Sign out</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default BumdesNav;
